<template>
  <div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        tags: [],

      }
    },
    props: {
      dirFilterMixin_onlineNowLabel: { 
        type: String, 
        default: "Online Now" 
      },
      dirFilterMixin_clearAllLabel: { 
        type: String, 
        default: "Clear All",
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      dirFilterMixin_filterDataComputed: function(){
        // sort by order ascending
        return Object.values(this.dirFilterMixin_categoryTypeFilterData).sort((a,b)=>a.order - b.order)
      },
      dirFilterMixin_userSelectionIsEmpty: function(){
        return Object.values(this.userSelection).flat().length === 0;
      },
      dirFilterMixin_categoryTypeFilterData: function(){
        let filteredData = [];
        if ((this.dir && this.dir.enable_enrollable_filter == true) || (this.$parent.dir && this.$parent.dir.enable_enrollable_filter == true)) {
          filteredData = Object.entries(this.filterData).filter((item)=>{
            return item[0] !== 'online_status'
          })
        } else {
          filteredData = Object.entries(this.filterData).filter((item)=>{
            return item[0] !== 'online_status' && item[0] !== 'Show Available'
          })
        }

        return Object.fromEntries(filteredData)
      },
      dirFilterMixin_filterKeyLabelMap: function(){
        let labelMap = {};
        for (let filterItem of this.dirFilterMixin_filterDataComputed){
          if (Array.isArray(filterItem.value_labels)){
            for (let [ind,k] in filterItem.values.entries()){
              labelMap[filterItem.values[ind]] = this.dirFilterMixin_formatLabel(filterItem.value_labels[ind])
            }
          }
          else {
            Object.assign(labelMap, filterItem.value_labels)
          }
        }
        return labelMap;
      },
    },
    methods: {
      dirFilterMixin_stripTags(str){
        let newStr = str.replace(/(<([^>]+)>)/ig, "");
        return newStr;
      }, 
      dirFilterMixin_formatLabel(label){
        let newLabel = this.dirFilterMixin_titleCase(label);
        newLabel = newLabel.replace(/_/g," ");
        return newLabel
      }, 
      dirFilterMixin_titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        return splitStr.join(' '); 
      },
      dirFilterMixin_removeTag(filterKey, tag,tagIndex){
        const copyOfUserSelection = JSON.parse(JSON.stringify(this.userSelection));
        copyOfUserSelection[filterKey].splice(tagIndex, 1)
        this.$emit('update:userSelection', copyOfUserSelection)
        this.dirFilterMixin_emitChanged()
      },
      dirFilterMixin_dropdownClicked() {
        /** override this */
      },
      dirFilterMixin_handleUserCheck($event,filterKey,filterOption){
        const copyOfUserSelection = JSON.parse(JSON.stringify(this.userSelection));
        if (!copyOfUserSelection[filterKey]){
          copyOfUserSelection[filterKey] = []
        }
        
        const indexInSelection = copyOfUserSelection[filterKey].indexOf(filterOption)
        if (indexInSelection === -1){
          copyOfUserSelection[filterKey].push(filterOption)
        }
        else{
          copyOfUserSelection[filterKey].splice(indexInSelection, 1)
        }
        // this.userSelection = {...this.userSelection}
        this.$emit('update:userSelection', copyOfUserSelection)
        this.dirFilterMixin_emitChanged()
      },
      dirFilterMixin_clearClicked(){
        const cleared = {};
        Object.keys(this.filterData).forEach(v => cleared[v] = [])

        this.$emit('update:userSelection', cleared)
        this.dirFilterMixin_emitChanged()
        
      },
      dirFilterMixin_emitChanged(){
        this.$nextTick(()=>{
          this.$emit('change', this.userSelection)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>